import { Button } from '../../../shared/ui/Button';
import { useSelector } from 'react-redux';
import { chatModel } from '../model';
import { useSend } from '../hooks';
import { IconMap } from '../../../shared/sprite';

export const ChatBotRetry = () => {
  const conversation = useSelector(chatModel.selectors.selectConversation);

  const { send } = useSend();

  return (
    <div className="flex flex-col gap-y-2 items-start justify-center">
      <p className="text-md text-error-600 ">
        There was an error generating a response.
      </p>
      <Button
        variant="text"
        color="secondary"
        size="sm"
        iconLeftName={IconMap.RefreshCcw04}
        iconLeftWidth={20}
        iconBlockClassName="mr-2 rotate-180"
        onClick={() => send(conversation?.request.prompt ?? '')}
        className="!font-semibold"
      >
        Retry
      </Button>
    </div>
  );
};
